// pages/Login/authUtils.js

export const getUser = () => {
  const user = localStorage.getItem("userDetails");
  return user ? JSON.parse(user) : null;
};

// ✅ Permissions live in localStorage("permissions")
export const getPermissions = () => {
  try {
    const raw = localStorage.getItem("permissions");
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    console.error("Failed to parse permissions:", e);
    return [];
  }
};

export const hasPermission = (perm) => {
  const perms = getPermissions();
  return perms.includes(perm);
};

export const getFieldAccess = () => {
  try {
    const raw = localStorage.getItem("fieldsAccess");
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    console.error("Failed to parse fieldsAccess:", e);
    return [];
  }
};

export const canAccessField = (fieldName) => {
  return getFieldAccess().includes(fieldName);
};

export const getUserRoles = () => {
  const user = getUser();
  return user?.role || [];
};
